import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalNavService, Context } from '@enelx/ngx-global-nav';
import { CookieService as NgxCookieService } from '@enelx/ngx-shared-services';
import { environment } from '../environments/environment.prod';
import { ApiEndpointsService } from './services/api-endpoints.service';
import { ApiService } from './shared/services/api.service';
import { MatSidenav } from '@angular/material/sidenav';
import { SidenavService } from './shared/services/sidenav.service';
import { NavService } from './shared/services/global-nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { MixPanelService } from './shared/services/mixpanel.service';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('sidenav') public sidenav: MatSidenav;
  orgList: Context[] = [];
  sidenavOpen = true;
  navUrl = '';

  mobileQuery: MediaQueryList;
  private readonly _mobileQueryListener: () => void;

  constructor(
    private translate: TranslateService,
    private apiEndpointsService: ApiEndpointsService,
    private apiService: ApiService,
    private globalNavService: GlobalNavService,
    private cookieService: NgxCookieService,
    private sidenavService: SidenavService,
    private navService: NavService,
    private mixpanelService: MixPanelService,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    this.getNavUrl();
    this.mobileQuery = media.matchMedia('(max-width: 1280px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  async getNavUrl() {
    this.navUrl = await this.navService.getNavUrl();
  }

  async ngOnInit() {
    this.globalNavService.userData$
      .pipe(
        filter((user) => !!user?.user_id),
        take(1),
      )
      .subscribe((user) => this.mixpanelService.initialize(user));

    // i18n - cobranding stuff
    const { defaults } = environment;
    const locale = this.cookieService.getI18NLocale() || defaults.locale;
    const brand = this.cookieService.getI18NBrand() || defaults.brand.toUpperCase();
    this.translate.setDefaultLang(`${defaults.locale}.${defaults.brand.toUpperCase()}`);
    this.translate.use(`${locale}.${brand}`).subscribe(() => {
      this.translate.get('APP.TITLE').subscribe((result) => {
        document.title = result;
      })
    });
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }
}
